export const FIRESTORE_COLLECTIONS = {
  preferences: 'preferences',
  drafts: 'drafts',
  timers: 'timers',
  snippets: 'snippetsV2',
  defaultTeamSnippets: 'defaultTeamSnippets',
  timeEntryDrafts: 'timeEntryDrafts',
  manualActions: 'manualActions'
};

export const FIREBASE_TIMER_DOC = {
  startedAt: 'startedAt',
  stoppedAt: 'stoppedAt'
};

export const generateTimerId = ({ memberId, ticketId }) => `${memberId}-${ticketId}`;
export const generateDraftId = ({ memberId, ticketId }) => `${memberId}-${ticketId}`;
